import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { ViewVariant } from "@/common/ts/layout";
import {
  BaseEntityDto,
  GeneralStatusMetaDto,
  GeneralStatusSubjectDto,
} from "@/core/api/generated/v1";

import EntityLink from "../../../components/EntityLink/EntityLink";
import GeneralStatusHistoryPaginatedList, {
  GeneralStatusHistoryPaginatedListProps,
} from "./GeneralStatusHistoryPaginatedList";

export interface OwnProps {
  listProps: GeneralStatusHistoryPaginatedListProps;
  subject: GeneralStatusSubjectDto | undefined;
  subjectEntity: BaseEntityDto | undefined;
  statusMeta: GeneralStatusMetaDto | undefined;
}

type Props = OwnProps & AppModalProps;

export default function GeneralStatusHistoryPaginatedListModal({
  listProps,
  subject,
  subjectEntity,
  statusMeta,
  ...dialogProps
}: Props) {
  return (
    <AppModal
      fullWidth
      maxWidth='lg'
      keepMounted={false}
      titleProps={{
        title: (
          <>
            Status history{" "}
            {subject && subject.entityType && subject.entityId && (
              <>
                for{" "}
                <EntityLink
                  entityType={subject.entityType}
                  entityId={subject.entityId}
                  entity={subjectEntity}
                  linkProps={{ inlineProps: { withIcon: false } }}
                />
              </>
            )}
          </>
        ),
      }}
      {...dialogProps}
    >
      <AppModalContent>
        <GeneralStatusHistoryPaginatedList
          {...listProps}
          displayProps={{
            viewVariant: ViewVariant.Tab, // TODO: must be Modal
            ...listProps?.displayProps,
          }}
          defaultValues={{
            ...listProps?.defaultValues,
            subjectEntityType: subject?.entityType || listProps?.defaultValues?.subjectEntityType,
            subjectEntityId: subject?.entityId || listProps?.defaultValues?.subjectEntityId,
            statusIdentifier:
              statusMeta?.statusIdentifier || listProps?.defaultValues?.statusIdentifier,
          }}
        />
      </AppModalContent>
    </AppModal>
  );
}
